module.exports = __webpack_public_path__ + "img/holdIdPhoto.2b01c7b2.png";